import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BMEventsType } from '../types';
import { MetricState } from './base-metric';
import { BasePageLoadMetric } from './base-page-load-metric';
export class PageLoadMetaMetric extends BasePageLoadMetric {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "activePageLoadMetric", null);
  }

  startPageLoad({
    cancelStarted,
    ...startPageLoadParams
  } = {
    isInitial: false,
    cancelStarted: false
  }) {
    if (cancelStarted || this.state !== MetricState.STARTED) {
      super.startPageLoad(startPageLoadParams);
    }
  }

  setActive(metric) {
    this.activePageLoadMetric = metric;
  }

  setDebug(debug) {
    this.config.debug = debug;
  }

  isDebugMode() {
    return this.config.debug;
  }

  isInitialLoad() {
    return this.isInitial;
  }

  clear() {
    this.activePageLoadMetric && this.activePageLoadMetric.cancel();
    super.clear();
  }

  include(metric) {
    if (!this.config.include) {
      this.config.include = [metric];
    } else {
      this.config.include.push(metric);
    }
  }

  experimental__addExplicitTiming(name, timing) {
    if (this.explicitTimings === null) {
      this.explicitTimings = {};
    }

    this.explicitTimings[name] = timing;
  }

}
export const pageLoadMetaMetric = new PageLoadMetaMetric({
  type: BMEventsType.PAGE_LOAD,
  key: 'page_load_meta_metric'
});